import { articles } from "@/mocks/opinion";

export default function ArticleSection() {
  const [featured, ...rest] = articles;

  return (
    <section id="read" className="bg-background-50">
      <div className="mx-auto max-w-6xl px-4 md:px-6 py-12 md:py-16">
        <div className="flex flex-col gap-2 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="inline-flex items-center gap-2 text-xs md:text-sm font-semibold uppercase tracking-widest text-primary-600">
              <span className="h-px w-6 bg-primary-500"></span> Deep Reads
            </p>
            <h2 className="mt-2 font-heading text-2xl md:text-4xl font-black text-foreground-950">专题精选</h2>
            <p className="mt-3 max-w-2xl text-sm md:text-base leading-relaxed text-foreground-700">
              不只呈现评论，更把来龙去脉与风向转折讲透。适合想真正理解一件事的深度读者。
            </p>
          </div>
        </div>

        {/* featured */}
        <article className="mt-8 overflow-hidden rounded-2xl border border-background-200 bg-background-100/60">
          <div className="grid grid-cols-1 lg:grid-cols-2">
            <div className="relative min-h-[220px] lg:min-h-[320px]">
              <img
                src={featured.image}
                alt={featured.title}
                className="absolute inset-0 h-full w-full object-cover object-center"
              />
              <span className="absolute left-4 top-4 rounded-full bg-primary-500 px-3 py-1 text-xs font-medium text-background-50">
                <i className="ri-star-fill mr-1" aria-hidden="true"></i>本期精选
              </span>
            </div>
            <div className="flex flex-col justify-center p-5 md:p-8">
              <div className="flex items-center gap-3 text-xs text-foreground-600">
                <span className="inline-flex items-center gap-1 rounded-full bg-accent-100 px-2.5 py-0.5 text-accent-900">
                  {featured.category}
                </span>
                <span className="inline-flex items-center gap-1">
                  <i className="ri-time-line" aria-hidden="true"></i>
                  {featured.date}
                </span>
                <span className="inline-flex items-center gap-1">
                  <i className="ri-eye-line" aria-hidden="true"></i>
                  {(featured.views / 1000).toFixed(1)}k 阅读
                </span>
              </div>
              <h3 className="mt-3 font-heading text-xl md:text-2xl font-black leading-snug text-foreground-950">
                {featured.title}
              </h3>
              <p className="mt-3 text-sm md:text-base leading-relaxed text-foreground-700">{featured.excerpt}</p>
              <div className="mt-5 flex flex-wrap items-center gap-3">
                <span className="inline-flex items-center gap-1 text-xs text-foreground-600">
                  <i className="ri-book-open-line" aria-hidden="true"></i>
                  {featured.readTime}
                </span>
                <a
                  href="#contact"
                  className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-primary-500 px-5 py-2 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
                >
                  开始阅读
                  <i className="ri-arrow-right-line" aria-hidden="true"></i>
                </a>
              </div>
            </div>
          </div>
        </article>

        {/* rest grid */}
        <div className="mt-6 grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
          {rest.map((a) => (
            <article
              key={a.id}
              className="group flex flex-col overflow-hidden rounded-xl border border-background-200 bg-background-50 transition-colors hover:border-secondary-300"
            >
              <a href="#contact" className="relative block h-40 overflow-hidden">
                <img
                  src={a.image}
                  alt={a.title}
                  className="h-full w-full object-cover object-center transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 rounded-full bg-background-50/95 px-2.5 py-0.5 text-xs font-medium text-foreground-800">
                  {a.category}
                </span>
              </a>
              <div className="flex flex-1 flex-col p-4 md:p-5">
                <h3 className="font-heading text-base font-bold leading-snug text-foreground-950 group-hover:text-primary-700">
                  <a href="#contact">{a.title}</a>
                </h3>
                <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-700 line-clamp-2">{a.excerpt}</p>
                <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-3 text-xs text-foreground-600">
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-calendar-line" aria-hidden="true"></i>
                    {a.date}
                  </span>
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-eye-line" aria-hidden="true"></i>
                    {(a.views / 1000).toFixed(1)}k
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}